'use strict'

// Client twin of server/src/hmi/routeOptimizer/crewEfficiency.js.
// Keep the pure math here EXACTLY in sync with the server module:
// wallClock(n) = manMinutes * factor(n) / n, where the curve maps
// crew size -> multiplier on required man-hours.

export const DEFAULT_CURVE = { 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1 }

export const factorFor = (crewSize, curve = DEFAULT_CURVE) => {
  // Non-finite or <= 0 crewSize -> neutral factor
  if (!Number.isFinite(crewSize) || crewSize <= 0) return 1

  // Round half-up, then clamp to [1, 6]
  const rounded = Math.round(crewSize)
  const clamped = Math.max(1, Math.min(6, rounded))

  const factor = Number(curve[clamped])
  if (!Number.isFinite(factor) || factor <= 0) return 1

  return factor
}

export const wallClockMinutes = (manMinutes, crewSize, curve = DEFAULT_CURVE) => {
  if (!Number.isFinite(manMinutes) || manMinutes <= 0) return 0

  // For division use the actual (potentially fractional) crew size;
  // fall back to 3 when crew size is missing/invalid
  const n = (Number.isFinite(crewSize) && crewSize > 0) ? crewSize : 3

  return Math.round(manMinutes * factorFor(n, curve) / n)
}
